import { IPagination } from '../../../../app.common/modules/common/models';

export interface IShopBusinessType {
    name: string;
    value: number;
    iconClass: string;
}

export interface IPaginationStoreTableResult {
    Items: IStoreTableModel[];
    Total: number;
}

export interface IStoreTableShortModel {
    Name: string;
    Description: string;
}

export interface IStoreTableModel extends IStoreTableShortModel {
    ID: number;
}

export interface IStoreTableModelWithOldName extends IStoreTableModel {
    OldName: string;
}

export interface IPaginationShopTables extends IPagination {
    data: IStoreTableModel[];
    setData: () => void;
}

export interface ITableSettings {
    TableOrderEnabled: boolean;
    TableSelectionMandatory: boolean;
}

export enum TableSettingEnum {
    TableService = 0,
    TableMandatorySelection = 1
  }



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/models/index.ts